import { f as r } from "./index743.mjs";
var o = r, s = o({}.isPrototypeOf);
export {
  s as o
};
